const pagesAccessesEn = {
  productHeader: {
    pageTitle: "Accesses",
  },
  nav: {
    overview: "Overview",
    logs: "Logs",
    software: "Software",
    alerts: "Alerts",
    contractAndCost: "Contract & Cost",
    settings: "Settings",
  },
  // 一覧画面
  tabs: {
    registered: "Registered Software",
    tolerated: "Tolerated IT Services",
    blocked: "Blocked IT Services",
    all: "All",
  },
  filter: {
    placeholder: "Filter...",
    date: "Date",
    people: "People",
    id: "ID",
    device: "Device",
    software: "Software",
  },
  help: {
    shadowIt: {
      title: "Shadow IT?",
      text: "These are access logs to software that is not connected to DRESS CODE, collected via the browser extension.<br />They are updated every hour, at the top of each hour.",
    },
    shadowID: {
      title: "Shadow Identity?",
      text: "These are access logs for try login to ID that is not connected to DRESS CODE, collected via the browser extension.<br />They are updated every hour, at the top of each hour.",
    },
  },
  table: {
    timestamp: "Timestamp",
    whoAccessed: "Who accessed",
    id: "ID",
    device: "Device",
    accessedTo: "Accessed to",
    action: "Action",
    visit: "Visit",
  },

  // アラート画面
  alerts: {
    sideTabs: {
      shadowIT: "Shadow IT",
      shadowID: "Shadow Identity",
      shadowAI: "Shadow AI",
      dormantIT: "Dormant IT",
      dormantID: "Dormant ID",
      dormantAI: "Dormant AI",
      closeSideTab: "Close side tab",
    },
    summary: {
      uniqueShadowIT: "Detected Shadow IT",
      uniqueShadowID: "Detected Shadow Identity",
      totalAccessCount: "Monthly unique accesses",
      uniqueMemberCount: "Monthly accessed people",
      fromLastMonth: "from last month",
      help: {
        uniqueShadowIT:
          "The total number of shadow IT services detected from the past up to this month.",
        uniqueShadowID:
          "The total number of shadow identities detected from the past up to this month.",
        totalAccessCount:
          "The total number of accesses collected this month from browsers with the browser extension installed.",
        uniqueMemberCount:
          "The number of unique users who accessed from browsers with the browser extension installed this month.",
      },
    },
    filter: {
      placeholder: "Filter...",
      itService: "IT Service",
      category: "Category",
      member: "Member",
    },
    table: {
      itService: "IT Service",
      category: "Category",
      uniqueUserCount: "Unique user count",
      members: "Members",
      access7Days: "7-day total access count",
      access30Days: "30-day total access count",
    },
    unknownUser: "Unknown user",
  },

  alertDetail: {
    pageTitle: "Alert Detail",
    breadcrumb: "Accesses",
    filter: {
      placeholder: "Filter...",
    },
  },

  pagination: {
    rows: "rows",
    rowsPerPage: "Rows per page",
    page: "Page",
    of: "of",
  },
};

export default pagesAccessesEn;
